import baseStorage from './baseStorage'
export default {
    keyword: 'menulist',
    set(value) {
        baseStorage.setStorage(this.keyword, JSON.stringify(value))
    },
    get() {
        var model = baseStorage.getStorage(this.keyword);
        if (model)
            return JSON.parse(model)
        return null
    },
    remove() {
        baseStorage.removeStorage(this.keyword);
    },


    moduleID: 'moduleID',
    setModuleID(value) {
        baseStorage.setStorage(this.moduleID, JSON.stringify(value))
    },
    getModuleID() {
        var model = baseStorage.getStorage(this.moduleID);
        if (model)
            return JSON.parse(model)
        return []
    },
}


// WEBPACK FOOTER //
// ./src/utils/storage/menuStorage.js